// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bk","message":"bl","header":"bm","subHeading":"bn","buttons":"bo","buttonWrapper":"bp","btn":"bq"};